import {CxEvent} from '@spartacus/core';
import {NavigationEvent} from '@spartacus/storefront';

export class ErrorPageEvent extends CxEvent {
  static readonly type = 'ErrorPageEvent';

  navigation: NavigationEvent;
  errorType?: string;
  pageSection?: string;
  description?: string;
}
